import { render } from "./CadClientes.vue?vue&type=template&id=4207fd95&scoped=true"
import script from "./CadClientes.vue?vue&type=script&lang=js"
export * from "./CadClientes.vue?vue&type=script&lang=js"

import "./CadClientes.vue?vue&type=style&index=0&id=4207fd95&scoped=true&lang=css"
import "./CadClientes.vue?vue&type=style&index=1&id=4207fd95&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4207fd95"]])

export default __exports__